import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Clickable } from "./Clickable.js";
import { useThemeFromContext } from "./theme.js";
const Link = forwardRef((props, ref) => {
  const { baseColor: baseColorProp, children, disabled, hover, style, variant, ...otherProps } = props;
  const { colors } = useThemeFromContext();
  const baseColor = baseColorProp || colors.accent;
  return jsx(Clickable, { ref, ...otherProps, disabled, style: {
    display: "inline",
    color: disabled ? colors.disabled() : baseColor(variant === "light" ? 0.3 : 1),
    cursor: disabled ? "not-allowed" : "pointer",
    fontWeight: 500,
    ...style
  }, hover: disabled ? void 0 : {
    color: baseColor(variant === "light" ? 0.1 : 0.8),
    ...hover
  }, children });
});
Link.displayName = "Link";
export {
  Link
};
